import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import CupomStatusBadge from './CupomStatusBadge';
import { Cupom } from '../../services/cupomService';

export interface CupomTableProps {
  cupons: Cupom[];
  page: number;
  rowsPerPage: number;
  total: number;
  onPageChange: (page: number, rowsPerPage: number) => void;
  onDelete: (codigo: string) => void;
  onEdit: (cupom: Cupom) => void;
}

const CupomTable: React.FC<CupomTableProps> = ({
  cupons,
  page,
  rowsPerPage,
  total,
  onPageChange,
  onDelete,
  onEdit,
}) => {
  const handleChangePage = (_: unknown, newPage: number) => {
    onPageChange(newPage, rowsPerPage);
  };
  const handleChangeRowsPerPage = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onPageChange(0, parseInt(e.target.value, 10));
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#6c757d' }}>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}></TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Código</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Tipo</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Valor</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Quantidade</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Expiração</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cupons.map((c) => (
            <TableRow key={c.codigo} hover>
                <TableCell>
                <i className="bi bi-ticket-fill bi-rotate-135" style={{ transform: 'rotate(45deg)' }} />
                </TableCell>
              <TableCell>{c.codigo}</TableCell>
              <TableCell>{c.tipo === 'PORCENTAGEM' ? '%' : 'R$'}</TableCell>
              <TableCell>
                {c.tipo === 'PORCENTAGEM'
                  ? `${c.valor}%`
                  : c.valor.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
              </TableCell>
              <TableCell>{c.quantidadeDisponivel ?? '-'}</TableCell>
              <TableCell>
                <CupomStatusBadge status={c.status || ''} />
              </TableCell>
              <TableCell
                sx={c.dataExpiracao && new Date(c.dataExpiracao) < new Date() ? { color: 'red' } : undefined}
              >
                {c.dataExpiracao
                  ? new Date(c.dataExpiracao).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
                  : '-'}
              </TableCell>
              <TableCell align="right">
                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    aria-label="Editar cupom"
                    onClick={() => onEdit(c)}
                  >
                    <i className="bi bi-pencil" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-link text-danger p-0"
                    onClick={() => onDelete(c.codigo)}
                  >
                    <i className="bi bi-trash" />
                  </button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </TableContainer>
  );
};

export default CupomTable;
